//let baseApp = 'https://admin.vanilla.returnado.com/'
//let baseApp = 'https://new-prod.returnado.com/'
let baseApp = 'https://dev.returnado.com/'

export const local = {
	environment: 'local',
	BASE_APP: baseApp,
	BASE_API: 'widget-api/$v/',
	// WARNING: widget url should not have a trailing slash
	WIDGET_URL: 'widget-ui',
}

export const aws = {
	environment: 'aws',
	BASE_APP: '',
	BASE_API: '../widget-api/$v/',
	// WARNING: widget url should not have a trailing slash
	WIDGET_URL: '../widget-ui',
}
